<table [ngClass]="cssClass(state?.dataSeverity)">
	<tr>
		<td rowspan="2">{{label}}</td>
		<td><i class="bi bi-check" [ngClass]="state?.resolved ? 'resolved' : ''"></i></td>
	</tr>
	<tr><td><i class="bi bi-chat-left-text" [ngClass]="cssClass(state?.commentsSeverity)"></i></td></tr>
</table>
